export default __webpack_public_path__ + "static/media/about-us.d49d8fc6.jpg";